import { spotDeadlineAt } from './marketPhase'

/** AC-BSP-125: 締切前に要確認になった札の表示上の入札中を保持する。 */
export const reviewStartedBeforeDeadline = (row: {
  needsReview?: boolean
  needsReviewSince?: Date
  targetDate?: Date
}): boolean =>
  row.needsReview === true &&
  row.needsReviewSince !== undefined &&
  row.targetDate !== undefined &&
  row.needsReviewSince < spotDeadlineAt(row.targetDate)
